import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dob-filter',
  templateUrl: './dob-filter.component.html'
})
export class DOBFilterComponent implements OnInit {
  @Input() dobFilterData;
  @Output() dobFilterOutput = new EventEmitter();
  public showDatepicker = false;
  public datePickerData;
  constructor() { }

  ngOnInit() {
    this.datePickerData = this.dobFilterData;
  }
  /* fn for toggling the date picker */
  public toggleDatePicker() {
    this.showDatepicker = !this.showDatepicker;
  }
  /* output event from date picker component */
  public eventFromDatePicker(event) {
    this.showDatepicker = false;
    this.dobFilterOutput.next(event);
  }
}
